/**
 * Created by daniel on 23/04/17.
 */

import * as actions from "./actions";

let initialState = {
  hoveredItem: null,
  selectedItem: null,
  draggedItem: null,
  dropzoneCoords: null,
  toolboxVisible: true,
  toolboxPinned: true,
  toolboxTab: 0,
};

export function ui(state = initialState, action) {
  switch (action.type) {
    case actions.SET_UI_HOVERED_CONTENT_ITEM:
      return {...state, hoveredItem: action.contentId};
    case actions.SET_UI_SELECTED_CONTENT_ITEM:
      let {contentId} = action;
      return {...state, selectedItem: action.contentId ? {contentId} : null};
    case actions.SET_UI_DRAGGED_CONTENT_ITEM:
      return {...state, draggedItem: action.contentItem};
    case actions.SET_UI_DROPZONE_COORDS:
      return {...state, dropzoneCoords: action.coords};
    case actions.SET_UI_TOOLBOX_VISIBILITY:
      return {...state, toolboxVisible: action.visible};
    case actions.SET_UI_TOOLBOX_PINNED:
      return {...state, toolboxPinned: action.pinned};
    case actions.SET_UI_TOOLBOX_ACTIVETAB:
      return {...state, toolboxTab: action.tab};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Editor/state/ui/reducers.js